import playwrightTest from "@playwright/test";
import { ERRORS } from "@texts/errors";
import consoleLogFormatted from "@utils/consoleLogFormatted";
const test = playwrightTest.extend({
    generateLighthouseMetaData: async ({}, use, testInfo) => {
        let reportNumber = 0;
        const { title, outputDir: directory } = testInfo;
        const generateLighthouseMetaData = () => {
            const safeTitle = title.replace(/[:]/g, "_");
            return {
                formats: { html: true },
                name: reportNumber ? safeTitle : `${safeTitle}-${reportNumber++}`,
                directory,
                get pathToLightHouseHTMLReport() {
                    return `${directory}/${this.name}.html`;
                },
            };
        };
        await use(generateLighthouseMetaData);
    },
    attachLighthouseReport: async ({}, use, testInfo) => {
        const attachLighthouse = async (pathToLightHouseHTMLReport) => {
            if (!pathToLightHouseHTMLReport.endsWith(".html")) {
                consoleLogFormatted.redText(ERRORS.fixtures.attachLightHouseReport.unsupportedFileType(pathToLightHouseHTMLReport));
                return;
            }
            await testInfo.attach("lighthouse", {
                path: pathToLightHouseHTMLReport,
                contentType: "text/html",
            });
        };
        await use(attachLighthouse);
    },
});
export default test;
//# sourceMappingURL=index.js.map